import { FixedSizeList } from "react-window";
import styled, { css } from "styled-components";
import { defaultBackground, primaryBackground, secondaryBackground } from "../../../helpers/background";
import color, { defaultColor, dividerColor, selectedColor } from "../../../helpers/color";
import scrollbar from "../../../helpers/scrollbar";
import textSize from "../../../helpers/textSize";
import Variable from "./Variable";
const List = /*#__PURE__*/styled.div.withConfig({
  displayName: "List",
  componentId: "sc-rbqsud-0"
})(["height:100%;& > *{", "}"], textSize);
List.Fixed = styled(FixedSizeList).withConfig({
  displayName: "Fixed",
  componentId: "sc-rbqsud-1"
})(["", " > *{position:relative;}"], scrollbar);
List.Variable = Variable;
List.Item = styled.div.withConfig({
  displayName: "Item",
  componentId: "sc-rbqsud-2"
})(["", " display:block;position:relative;color:", ";transition:background-image 0.2s ease-in-out;", " ", " ", " ", " ", " ", ""], defaultBackground, color, ({
  first
}) => !first && css(["border-top:2px solid ", ";"], dividerColor), ({
  last
}) => last && css(["border-bottom:2px solid ", ";"], dividerColor), ({
  sticky
}) => sticky && css(["position:sticky;bottom:0;"]), ({
  disabled
}) => disabled && css(["", " opacity:0.5;"], secondaryBackground), ({
  active
}) => active && css(["", " z-index:1;"], primaryBackground), ({
  onClick
}) => onClick && css(["cursor:pointer;&:hover{color:", ";}"], props => props.color ? color(props) : selectedColor(props)));
List.Header = styled.div.withConfig({
  displayName: "Header",
  componentId: "sc-rbqsud-3"
})(["", " width:70px;padding:2px 10px 2px 0;color:", ";text-align:right;"], secondaryBackground, defaultColor);
List.Text = styled.div.withConfig({
  displayName: "Text",
  componentId: "sc-rbqsud-4"
})(["* + &{margin-left:10px;}"]);
List.Hover = styled.div.withConfig({
  displayName: "Hover",
  componentId: "sc-rbqsud-5"
})(["opacity:0;transition:opacity 0.2s ease-in-out;", ":hover &{opacity:1;}"], List.Item);
List.displayName = "List";
List.Item.displayName = `${List.displayName}.Item`;
List.Text.displayName = `${List.displayName}.Text`;
List.Hover.displayName = `${List.displayName}.Hover`;
List.Header.displayName = `${List.displayName}.Header`;
export default List;
//# sourceMappingURL=index.js.map